/**
 * Generic AI response when an API error occurs.
 */
export const aiCatchAllErrorMessage =
  "I'm sorry, I'm having trouble answering that. Please rephrase or simplify the question and ensure all mathematical notation is correct, then resubmit it." +
  "<br><br>" +
  "Or we have tutors online right now who can assist if you'd like.";
